module.exports = __webpack_public_path__ + "img/Food-low.27369d04.jpg";